// Iter61l — Timezone-safe date helpers.
//
// The classic JS bug: `new Date('2026-02-13')` is parsed as UTC 00:00, then
// `.toLocaleDateString()` in a NON-UTC timezone can shift the day by ±1.
// Same for `new Date().toISOString().slice(0, 10)` at late/early hours.
//
// These helpers always work in the USER's LOCAL timezone.

/** YYYY-MM-DD for a Date in local timezone. */
export function localISO(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Today in local timezone as YYYY-MM-DD */
export function localToday() {
  return localISO(new Date());
}

/**
 * Parse a "YYYY-MM-DD" (or "YYYY-MM-DDTHH:MM:SS") string as a LOCAL Date.
 * Avoids the UTC interpretation `new Date('2026-02-13')` would apply.
 * If given a full ISO with 'Z' timezone, parses that (respecting UTC).
 */
export function parseLocalDate(iso) {
  if (!iso) return null;
  const s = String(iso);
  // If it already has a timezone (Z or ±HH:MM), let JS parse it.
  if (/[Z+]/.test(s) || /-\d{2}:\d{2}$/.test(s.slice(10))) {
    return new Date(s);
  }
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?/);
  if (!m) return new Date(s);
  const [, y, mo, d, hh, mm, ss] = m;
  return new Date(
    parseInt(y, 10),
    parseInt(mo, 10) - 1,
    parseInt(d, 10),
    hh ? parseInt(hh, 10) : 0,
    mm ? parseInt(mm, 10) : 0,
    ss ? parseInt(ss, 10) : 0,
  );
}

/** Add N days to a YYYY-MM-DD string, stays in local. */
export function addDaysISO(iso, n) {
  const d = parseLocalDate(iso) || new Date();
  d.setDate(d.getDate() + n);
  return localISO(d);
}

/** Format a due_date string for display in French, safely (local). */
export function formatDay(iso, opts = { day: '2-digit', month: 'short' }) {
  const d = parseLocalDate(iso);
  if (!d) return '';
  return d.toLocaleDateString('fr-FR', opts);
}
